<template>
  <div class="tab-pane" :id="`tabs-1.${index}`" role="tabpanel">
    <div class="lesiurpackages_box organized tours packages_boby" v-if="applyFilter.length>0">
      <!-- <div class="row packages_boby_grid masonrybox" data-masonry='{"percentPosition": true }'>
        <LesiurtabItem v-for="(item, idx) in mergedDeals" :key="idx" :items="item" />
      </div> -->
      <div v-masonry transition-duration="1s" item-selector=".item" class="masonry-containerrow packages_boby_grid masonrybox" data-masonry='{"percentPosition": true }'>
        <component :is="isLiveshowItem(item) ? 'LesiurtabItemLiveshow' : 'LesiurtabItem'" v-masonry-tile class="item" v-for="(item, idx) in mergedDeals" :key="idx" :items="item" :dealCatetoryId="dealCatetoryId" />
      </div>
    </div>
    <div class="d-flex loadMore">
      <button style="height: 40px" @click="loadMore" v-if="this.dealListItem.list.length > this.setNum">{{ $t('home.show-more') }}</button>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { VueMasonryPlugin } from 'vue-masonry';
import TemplateLesiurTabContent from './TemplateLesiurtabContent';

Vue.use(VueMasonryPlugin);

export default {
  name: 'tabContentTheme1',
  mixins: [TemplateLesiurTabContent],
  components: {
    LesiurtabItem: () => import('@/components/home/lesiurtabItem/LesiurtabItemTheme1'),
    LesiurtabItemLiveshow: () => import('@/components/home/lesiurtabItem/LesiurtabItemTheme4'),
  },
  computed: {
    mergedDeals() {
      return this.applyFilter.reduce((accumulator, currentValue) => accumulator.concat(currentValue),
        []);
    },
  },
  methods: {
    isLiveshowItem(item) {
      return item && item[1] && item[1][0] && item[1][0].isLiveshowProduct === true;
    },
  },
  watch: {
    active() {
      if (this.active) {
        this.$redrawVueMasonry();
      }
    },
  },
  mounted() {
    this.$redrawVueMasonry();
  },
};
</script>
<style scoped>
.loadMore {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.loadMore > button {
  padding: 10px 24px;
  border-radius: 50px;
  border: 1px solid rgb(0, 97, 171);
  border: 1px solid rgba(var(--theme-primary));
  cursor: pointer;
}
.theme1 .lesiurpackages_box{
  margin-top: 0px;
}
</style>
